import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App.js';
import { RouteErrorBoundary } from './components/RouteErrorBoundary.js';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('Missing #root');
createRoot(root).render(
  <React.StrictMode>
    <BrowserRouter>
      {/* Catches anything that fails above the shell — auth bootstrap, setup
          probe, the shell itself. No navigation exists to offer here. */}
      <RouteErrorBoundary fallbackTitle="The portal could not start">
        <App />
      </RouteErrorBoundary>
    </BrowserRouter>
  </React.StrictMode>,
);
